import connection from '@/api/connection'

// export const singIn = async ({ commit }, user) => {
//     tr
// }

export const loadInputs = async ({ commit }, query = null) => {
    let page = 1;
    let search = '';
    let perPage = 25;
    let clientId = -1;
      
    if(query !== null){
      page = query?.page || 1;
      search = query?.search || '';
      perPage = query?.perPage || 25;
      clientId = query?.client?.id || -1
    }

    commit('setInputIsLoading', true);
    let url = `/inputs`;
    if (search === '') {
      url = `${url}?page=${page}&perPage=${perPage}&status=finalized&clientId=${clientId}`;
    } else {
      url = `${url}?search=${search}&page=${page}&perPage=${perPage}&status=finalized&clientId=${clientId}`;
    }

    await connection.get(url)
      .then(res => {
        const inputs = res.data.data;
        commit('setInputs', inputs);
        const pagination = {
            totalItems: res.data.totalItems,  // total number of elements or items
            // per_page: res.data.per_page, // items per page
            currentPage: res.data.currentPage, // current page (it will be automatically updated when users clicks on some page number).
            totalPages: res.data.totalPages, // total pages in record

            perPage: res.data.perPage 
        }
        res.data.pagination = pagination;
        commit('setInputsPaginated', res.data);
        commit('setInputIsLoading', false);
      }).catch(err => {
        console.log('error', err);
        commit('setInputIsLoading', false);
      });
}

export const loadInputsUnplaced = async ({ commit }) => {
  commit('setIsLoadingInputsUnplaceData', true);

  await connection.get('/inputs/unplaced')
      .then(res => {
        commit('setInputsUnplacedData', res.data.data);
        commit('setIsLoadingInputsUnplaceData', false);
      }).catch(err => {
        console.log('error', err);
        commit('setIsLoadingInputsUnplaceData', false);
      });
}

export const inputById = async ({ commit }, id) => {
  commit('setInputIsLoading', true);
  await connection.get(`/inputs/${id}`)
    .then(res => {
      commit('setInputDetail', res.data.data);
      commit('setInputIsLoading', false);
    }).catch(err => {
      console.log('error', err);
      commit('setInputIsLoading', false);
    });
}
